<template>
  <span class="tw-text-sm tw-text-neutral-900">
    Do you approve?
  </span>
</template>
